'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createPageOptions;

var _reactSideEffect = require('react-side-effect');

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducePropsToState = function reducePropsToState(propsList) {
    return propsList.reduce(function (acc, props) {
        return (0, _extends3.default)({}, acc, props, {
            keywords: (0, _extends3.default)({}, acc.keywords || {}, props.keywords || {})
        });
    }, {});
};
var NullComponent = function NullComponent() {
    return null;
};

function createPageOptions(handleStateChangeOnClient, mapStateOnServer) {
    return (0, _reactSideEffect2.default)(reducePropsToState, handleStateChangeOnClient, mapStateOnServer)(NullComponent);
}
//# sourceMappingURL=PageOptions.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-components/lib/PageOptions/PageOptions.js
 ** module id = 460
 ** module chunks = 1
 **/